import React from 'react';
import styles from './Pagination.module.css';

export default function Pagination({ page, size, total, onPage }) {
    const pages = Math.max(1, Math.ceil((total || 0) / (size || 10)));
    if (pages <= 1) return null;

    const around = (p) => {
        const set = new Set([1, pages, p - 2, p - 1, p, p + 1, p + 2]);
        return [...set].filter(n => n >= 1 && n <= pages).sort((a, b) => a - b);
    };

    const seq = around(page || 1);

    return (
        <nav className={styles.nav} aria-label="Pagination">
            {seq.map((n, i) => (
                <React.Fragment key={n}>
                    {i > 0 && seq[i - 1] !== n - 1 && <span className={styles.ellipsis}>…</span>}
                    <button
                        type="button"
                        className={`${styles.page} ${n === page ? styles.active : ''}`}
                        onClick={() => n !== page && onPage && onPage(n)}
                        aria-current={n === page ? 'page' : undefined}
                        aria-label={`Go to page ${n}`}
                    >
                        {n}
                    </button>
                </React.Fragment>
            ))}
        </nav>
    );
}
